var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-container"},[_c('div',{staticClass:"lux-empty"},[_c('img',{attrs:{"src":_vm.img.lux.empty}}),_c('div',{staticClass:"empty-text"},[_vm._v("建设中")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }